// MoneyFollowsChild.jsx
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillWave, faSchool, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import CompensationNormsList from './CompensationNormsList';
import PrivateKindergartensList from './PrivateKindergartensList';
import '../../../kindergartens/detail/components/QueueFull/cabinet-zdo-requests.css';
import './money-follows-child.css';

const MoneyFollowsChild = () => {
  const [activeTab, setActiveTab] = useState('norms');

  const tabs = [
    { id: 'norms', label: 'Норми компенсації', icon: faMoneyBillWave },
    { id: 'kindergartens', label: 'Перелік садочків', icon: faSchool }
  ];

  return (
    <main className="queuetable-main-content queuetable-page">
      <div className="container-fluid">
        <div className="queuetable-content-wrapper">
          {/* Панель табов */}
          <div className="queuetable-year-bar d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="queuetable-label text-white-50">Гроші ходять за дитиною</span>
              <ul className="queuetable-year-tabs nav nav-tabs">
                {tabs.map((tab) => (
                  <li key={tab.id} className="nav-item">
                    <button
                      className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <FontAwesomeIcon icon={tab.icon} className="me-2" />
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Контент вкладок */}
          <div className="money-follows-child-content">
            {activeTab === 'norms' && <CompensationNormsList />}
            {activeTab === 'kindergartens' && <PrivateKindergartensList />}
          </div>
        </div>
      </div>
    </main>
  );
};

export default MoneyFollowsChild;